import { alpha } from '@mui/material/styles';
import theme from 'theme';

export const INVALID_WATERFALL_RESULTS_STYLES = {
  filter: 'blur(3px)',
  opacity: 0.7,
  pointerEvents: 'none',
  userSelect: 'none',
} as const;

export const INVALID_WATERFALL_MESSAGE_STYLES = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  justifyContent: 'center',
  p: 2,
  textAlign: 'center',
  textShadow: `0 0 4px ${theme.palette.background?.paper ?? '#fff'}, 0 0 8px ${theme.palette.background?.paper ?? '#fff'}`,
} as const;

export const INVALID_WATERFALL_OVERLAY_STYLES = {
  ...INVALID_WATERFALL_MESSAGE_STYLES,
  backgroundColor: alpha(theme.palette.background?.paper ?? '#fff', 0.45),
  inset: 0,
  // Keep the text aligned with the tables while covering the full scrollbar.
  pl: 3.5,
  position: 'absolute',
  zIndex: 1,
} as const;
